import { createContext, useContext } from 'react';

export const ClassicReaderZoomFractionContext = createContext<number | null>(null);
export const useClassicReaderZoomFraction = () => {
  const zoomFraction = useContext(ClassicReaderZoomFractionContext);
  if (!zoomFraction) {
    throw new Error('ClassicReaderZoomFractionContext not found');
  }
  return zoomFraction;
};
